if (!customElements.get('europelab-header')) {
  customElements.define('europelab-header', class extends HTMLElement {
    connectedCallback() {
      this.menuEvents?.abort();
      this.menuEvents = new AbortController();
      const menuOptions = { signal: this.menuEvents.signal };
      const menu = this.querySelector('.eh__mobile');
      if (menu) {
        document.addEventListener('click', event => {
          if (matchMedia('(max-width: 749px)').matches && menu.open && !menu.contains(event.target)) menu.open = false;
        }, menuOptions);
        menu.addEventListener('keydown', event => {
          if (event.key === 'Escape' && menu.open) {
            event.preventDefault();
            menu.open = false;
            menu.querySelector('summary').focus();
          }
        }, menuOptions);
        menu.querySelector('nav').addEventListener('click', event => {
          if (event.target.closest('a')) menu.open = false;
        }, menuOptions);
      }
      this.updateBackground = () => this.toggleAttribute('data-scrolled', window.scrollY > 32);
      this.updateBackground();
      window.addEventListener('scroll', this.updateBackground, { passive: true });
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.updateBackground);
      this.menuEvents?.abort();
    }
  });
}

if (!customElements.get('europelab-search')) {
  customElements.define('europelab-search', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.panel = this.querySelector('.eh__results');
      this.list = this.querySelector('ul');
      this.status = this.querySelector('[role="status"]');
      this.clearButton = this.querySelector('button');
      this.vialImages = JSON.parse(this.querySelector('[data-vial-images]').textContent);
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.input.addEventListener('input', () => this.schedule(), options);
      this.input.addEventListener('focus', () => { if (this.input.value.trim()) this.schedule(); }, options);
      this.querySelector('form').addEventListener('submit', event => { event.preventDefault(); this.schedule(0); }, options);
      this.clearButton.addEventListener('click', () => { this.input.value = ''; this.schedule(); this.input.focus(); }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') { this.input.focus(); this.close(); }
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          const links = [...this.list.querySelectorAll('a')];
          if (this.panel.hidden || !links.length) return;
          event.preventDefault();
          const index = links.indexOf(document.activeElement);
          const next = event.key === 'ArrowDown' ? index + 1 : index - 1;
          if (next < 0) this.input.focus(); else links[Math.min(next, links.length - 1)].focus();
        }
      }, options);
      document.addEventListener('click', event => { if (!this.contains(event.target)) this.close(); }, options);
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) this.close(); }, options);
    }
    close() {
      clearTimeout(this.timer);
      this.request?.abort();
      this.panel.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
    }
    schedule(delay = 250) {
      clearTimeout(this.timer);
      this.request?.abort();
      this.clearButton.hidden = !this.input.value;
      const query = this.input.value.trim();
      this.list.replaceChildren();
      if (!query) { this.close(); return; }
      this.panel.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      this.status.textContent = 'Wyszukiwanie…';
      this.timer = setTimeout(() => this.search(query), delay);
    }
    async search(query) {
      const request = new AbortController();
      this.request = request;
      try {
        const url = new URL(this.dataset.endpoint + '.json', location.origin);
        url.search = new URLSearchParams({ q: query, 'resources[type]': 'product', 'resources[limit]': '5' });
        const response = await fetch(url, { signal: request.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        if (request.signal.aborted || query !== this.input.value.trim()) return;
        const products = data.resources.results.products;
        const currency = this.dataset.currency;
        this.list.replaceChildren();
        for (const product of products) {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = product.url;
          const customImage = this.vialImages[product.handle];
          if (customImage || product.image) {
            const thumbnail = document.createElement('span');
            thumbnail.className = 'eh__result-thumb';
            const image = document.createElement('img');
            const imageUrl = new URL(customImage || product.image, location.origin);
            if (!customImage) imageUrl.searchParams.set('width', '160');
            image.src = imageUrl.href; image.alt = ''; image.width = 72; image.height = 84;
            if (customImage) image.className = 'eh__result-vial';
            thumbnail.append(image); link.append(thumbnail);
          }
          const text = document.createElement('span');
          const title = document.createElement('strong'); title.textContent = product.title;
          const price = document.createElement('small');
          const formatPrice = value => new Intl.NumberFormat(document.documentElement.lang || 'pl', { style: 'currency', currency }).format(value);
          if (this.dataset.drop === 'true') {
            const original = document.createElement('s');
            original.textContent = formatPrice(Number(product.price));
            price.append(document.createTextNode(formatPrice(Math.round(Number(product.price) * 100 * .8) / 100) + ' '), original);
          } else price.textContent = formatPrice(Number(product.price));
          text.className = 'eh__result-text';
          const arrow = document.createElement('span'); arrow.className = 'eh__result-arrow'; arrow.textContent = '↗'; arrow.setAttribute('aria-hidden', 'true');
          text.append(title, price); link.append(text, arrow); item.append(link); this.list.append(item);
        }
        this.status.textContent = products.length ? 'Znalezione produkty: ' + products.length : 'Brak wyników. Spróbuj innej nazwy.';
      } catch (error) {
        if (error.name !== 'AbortError' && !request.signal.aborted) this.status.textContent = 'Nie udało się pobrać wyników. Spróbuj ponownie.';
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.request?.abort();
      this.events?.abort();
    }
  });
}
